import Component from '@glimmer/component';
import MarkdownIt from 'markdown-it';

const md = new MarkdownIt({
  html: true,
  breaks: true,
  linkify: true,
  typographer: true,
});

export default class Markdown extends Component {
  get html() {
    if (!this.args.markdown) {
      return '';
    }

    let rendered = md.render(this.args.markdown);
    
    // Apply styling classes to match the site's design
    rendered = rendered
      .replace(/<p>/g, '<p class="post-open-text">')
      .replace(/<h1>/g, '<h1 class="post-open-subtitle">')
      .replace(/<h2>/g, '<h2 class="post-open-subtitle">')
      .replace(/<h3>/g, '<h3 class="post-open-subtitle">')
      .replace(/<h4>/g, '<h4 class="post-open-subtitle">')
      .replace(/<h5>/g, '<h5 class="post-open-subtitle">')
      .replace(/<h6>/g, '<h6 class="post-open-subtitle">')
      .replace(/<blockquote>/g, '<div class="post-open-quote"><blockquote class="quote-text">')
      .replace(/<\/blockquote>/g, '</blockquote></div>')
      .replace(/<ul>/g, '<div class="bullet-list bullet-list-grid"><ul>')
      .replace(/<\/ul>/g, '</ul></div>')
      .replace(/<li>/g, '<li class="bullet-list-item"><div class="bullet-list-item-icon"><svg class="check-icon"><use href="#svg-check"></use></svg></div><p class="bullet-list-item-text">')
      .replace(/<\/li>/g, '</p></li>')
      .replace(/<ol>/g, '<div class="bullet-list bullet-list-grid"><ol>')
      .replace(/<\/ol>/g, '</ol></div>')
      .replace(/<pre>/g, '<pre class="post-code-block">')
      .replace(/<code>/g, '<code class="post-code">')
      .replace(/<strong>/g, '<strong>')
      .replace(/<em>/g, '<em>')
      .replace(/<a href="([^"]*)"/g, '<a href="$1" class="post-link"');

    return rendered;
  }

  <template>
    <div class="post-content-formatted">
      {{{this.html}}}
    </div>
  </template>
}
